import angular from 'angular';
import Rx from 'rx';
import moment from 'moment';
import DialogController from './dialog';

export default function MemberAccountTradeCtrl($scope, WampCall, progressBar, $stateParams, UserService, $mdDialog, $sce, $timeout, $wamp, $mdMedia, $window) {

  var tradeUri = 'org.eggs.trade_info';
  var transactionsUri = 'org.eggs.trade_transactions';
  var notesUri = 'org.eggs.trade_notes';
  var user = Rx.Observable.fromPromise(UserService.load()).share();
  const screenWidth = $window.innerWidth;
  const screenHeight = $window.innerHeight;

  $scope.mdMedia = $mdMedia;
  // backend host for links built in the template (see webpack DefinePlugin)
  $scope.apiHost = __API_HOST__;

  var s1 = user
    .do(function (u) {
      progressBar.add(tradeUri);
      $scope.user = u;
    })
    .flatMap(function (user) {
      return new WampCall(tradeUri, [$stateParams.id, user.company_id]);
    })
    .do(function () {
      progressBar.remove(tradeUri);
    })
    .map(function (trade) {
      return trade[0];
    })
    .filter(function (filter) {
      return filter;
    })
    .map(function (trade) {
      //Display Price
      var pickupAdj = trade.PickUp == '1' ? parseFloat(trade.SalePrice) - parseFloat(trade.DockPrice) : 0;

      trade.DisplayPrice = trade.MarketRegion ?
        trade.DisplayPrice = Math.round(parseFloat(trade.Market) - pickupAdj).toFixed(2) + " " + trade.MarketRegion + " " + trade.MarketSize :
        trade.DisplayPrice = Math.round(parseFloat(trade.SalePrice) - pickupAdj).toFixed(2);

      return trade;

    })
    .subscribe(function (trade) {
      $scope.$apply(function () {
        $scope.trade = trade;

        var dd = trade.Pickup === 0
          ? moment(trade.DeliveryDate, "MMM D YYYY hh:mm:ss:SSSa")
          : moment(trade.ShipDate, "MMM D YYYY hh:mm:ss:SSSa");

        // console.log('diff', moment().diff(dd));

        //Need Case Count
        if (trade.Role === "Buyer") {
          $scope.needCC = moment().diff(dd) >= 0 && trade.BuyerCaseCount == null && trade.BalBuyer != 0;
        } else {
          $scope.needCC = moment().diff(dd) >= 0 && trade.SellerCaseCount == null && trade.BalSeller != 0;
        }

        if ($scope.needCC) {
          $timeout(function () {
            $scope.caseCount();
          });
        }

        //Need Invoice
        if (trade.Role !== "Buyer"
          && (trade.InvoiceNo == null || trade.InvoiceNo === '')
          && !$scope.needCC && trade.DeliveredDate) {

          $scope.needInvoice = true;

          $timeout(function () {
            $scope.invoice();
          });
        }

      });
    });

  $scope.transactionBalance = 0;
  var transactionSubscription = user
    .do(function () {
      progressBar.add(transactionsUri);
    })
    .flatMap(function (user) {
      return new WampCall(transactionsUri, [$stateParams.id, user.id]);
    })
    .do(function () {
      progressBar.remove(transactionsUri);
    })
    .subscribe(function (transactions) {
      $scope.$apply(function () {
        $scope.transactions = transactions;

        $scope.transactionBalance = transactions
          .map(function (transaction) {
            return parseFloat(transaction.Total);
          })
          .reduce(function (accum, value) {
            return accum + value;
          }, 0);
      });
    });

  var notesSubscription = user
    .do(function () {
      progressBar.add(notesUri);
    })
    .flatMap(function (user) {
      return new WampCall(notesUri, [$stateParams.id, user.id]);
    })
    .do(function () {
      progressBar.remove(notesUri);
    })
    .subscribe(function (notes) {
      $scope.$apply(function () {
        $scope.notes = notes;
      });
    });

  $scope.$on('$destroy', function () {
    var disposable = new Rx.CompositeDisposable(s1, transactionSubscription, notesSubscription);
    disposable.dispose();
  });

  $scope.caseCount = function () {
    $mdDialog.show({
      controller: ['$scope', '$mdDialog', DialogController],
      template: require('../views/report-casecount-dialog.html'),
      parent: angular.element('body'),
      clickOutsideToClose: true,
      disableParentScroll: false,
      fullscreen: false,
      openFrom: angular.element('#info'),
      closeTo: angular.element('#info'),
      scope: $scope,
      preserveScope: true

    });
  };

  $scope.invoice = function () {
    $mdDialog.show({
      controller: ['$scope', '$mdDialog', DialogController],
      template: require('../views/report-invoice-dialog.html'),
      parent: angular.element('body'),
      clickOutsideToClose: true,
      disableParentScroll: false,
      fullscreen: false,
      openFrom: angular.element('#info'),
      closeTo: angular.element('#info'),
      scope: $scope,
      preserveScope: true

    });
  };

  $scope.submitCaseCount = function (cc) {
    $wamp.call('org.eggs.submit_casecount', [parseInt($scope.trade.TradeNO), parseInt(cc.count), cc.notes])
      .then(function (r) {
        if ($scope.trade.Role === "Buyer") {
          $scope.trade.BuyerCaseCount = cc.count;
        } else {
          $scope.trade.SellerCaseCount = cc.count;
        }
        $mdDialog.hide();
      });
  };

  $scope.submitInvoice = function (invoice) {
    $wamp.call('org.eggs.submit_invoice', [parseInt($scope.trade.TradeNO), invoice.number, invoice.amount, invoice.notes])
      .then(function (r) {
        $scope.trade.InvoiceNo = invoice.number;
        $mdDialog.hide();
      });
  };

  $scope.documents = [];
  $wamp.call('org.eggs.get_linked_document_items', [$stateParams.id]).then(
    function (res) {
      // console.log(res.args);
      $scope.documents = res.args || [];
    });

  $wamp.call('org.eggs.get_invoice_url', [$stateParams.id]).then(
    function (res) {
      $timeout(function () {
        $scope.url = res.url;
      });
    });

  $scope.loadDoc = (document) => {
    $wamp.call("org.eggs.get_image_key_for_linked_document_item", [document.id]).then(
      function (key) {
        // debugger;
        $scope.url = $sce.trustAsResourceUrl("https://" + __API_HOST__ + "/api3/image?token=" + key);
        $scope.rotation = document.rotation + 'deg';
        $scope.getImageDimensions = function(event) {
          const imageElement = event.target;
          // $scope.width = imageElement.width * (100-((imageElement.width - screenWidth)/screenWidth));
          // $scope.width =  (((imageElement.width - screenWidth)/screenWidth));
          $scope.height = imageElement.height * 0.8;
          // console.log('Image dimensions: ' + $scope.width + 'x' + $scope.height, 'rotated', document.rotation);
        };

        // $scope.url = $sce.trustAsResourceUrl("http://localhost:8000/image?token=" + key);
        $mdDialog.show({
          controller: ['$scope', '$mdDialog', DialogController],
          template: require('../views/notes-dialog.html'),
          parent: angular.element(document.body),
          //targetEvent: ev,
          clickOutsideToClose: true,
          openFrom: '#note' + $stateParams.noteId,
          closeTo: '#note' + $stateParams.noteId,
          fullscreen: true,
          scope: $scope,
          preserveScope: true,
          onRemoving: function () {
            // $state.go('^');
          }
        });
      });
  };

  $scope.docTypeMap = {
    'bol-buyer': 'BOL Buyer',
    'bol-seller': 'BOL Seller',
    'bol-freight': 'BOL Freight',
    'seller-invoice': 'Seller Invoice',
    'freight-invoice': 'Freight Invoice',
    'buyer-invoice': 'Buyer Invoice',
    'purchase-order': `Purchase Order`,
    'sales-order': 'Sales Order',
    'promised-check-collection': 'Promised Check',
    'usda-cert': 'USDA Cert',
    'origin-cert': 'Origin Cert',
    'damage-pic': 'Damage Pic',
    'picture': 'Picture',
    'label': 'Label',
    'weight-ticket': 'Weight Ticket',
    'wash-ticket': 'Wash Ticket',
    'other': 'Other'
  };

}
